import xss, { whiteList as xssWhitelist } from 'xss';
import type {IWhiteList} from 'xss';
const customXssWhitelist: IWhiteList = {};
Object.keys(xssWhitelist).forEach(key => {
  customXssWhitelist[key] = [...(xssWhitelist[key] || ''), 'class', 'id', 'data-test'];
});

const customXss = (html: string) => xss(html, { whiteList: customXssWhitelist });
export default customXss;
